import React from "react";
import { SEASON_PHASE_META } from "../constants";
import { leagueLedgerSubline } from "../helpers";

export default function LeagueCandidateRow({ candidate, selected, onSelect }) {
  const phase = candidate.seasonPhase || "unknown";
  const phaseMeta = SEASON_PHASE_META[phase] || SEASON_PHASE_META.unknown;

  return (
    <button
      type="button"
      className={`amf-row alg-row alg-candidate-row ${selected ? "amf-row-selected" : ""} alg-row-${phase}`}
      aria-pressed={selected}
      onClick={onSelect}
    >
      <span className="alg-row-logo">
        {candidate.logo ? (
          <img src={candidate.logo} alt="" />
        ) : (
          <span className="alg-row-logo-fallback">{candidate.name?.[0] || "?"}</span>
        )}
      </span>
      <span className="amf-row-body alg-row-body">
        <span className="amf-row-top alg-row-top">
          <span className="amf-row-name">{candidate.name}</span>
          <span className={`amf-row-tag ${phaseMeta.tag}`}>{phaseMeta.label}</span>
        </span>
        <span className="amf-row-sub alg-row-sub">
          {leagueLedgerSubline(candidate)}
          {candidate.apiId != null ? ` · API ${candidate.apiId}` : ""}
        </span>
      </span>
    </button>
  );
}
